import 'dayjs/locale/de';
import 'dayjs/locale/en';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from './utils/dayjsConfig';

export const DayjsLocaleListener = () => {
  const { i18n } = useTranslation();
  useEffect(() => {
    dayjs.locale(i18n.language);
  }, [i18n.language]);
  return null;
};
